import _app from '../../../server';

import React from 'react';
import PropTypes from 'prop-types';

import {
    Col
} from 'reactstrap';

const PictureAdapter = props => {
    let storage = JSON.parse(localStorage.getItem("guardexpert_logon"));

    let show = props.pictures.slice(props.startIndex, props.lastIndex);
    if (typeof (show) === 'undefined') {
        return null
    }
    return show.map((p) => {
        let link = `${_app.api}Storages/${p.container}/download/${p.filename}?access_token=${storage.info.id}`
        let cssBorder = ''
        if (p.id === props.selectedId) {
            cssBorder = 'border border-danger'
        }
        return (
            <Col key={p.id} xs="3" className="px-1 px-md-3">
                <img
                    onClick={() => { props.onSelected(p.id) }}
                    className={cssBorder}
                    src={link}
                    alt="Evidence"
                    style={{ height: "64px", display: "block", maxWidth: "100%", marginTop: "5px" }}
                />
            </Col>
        )
    })
};

PictureAdapter.propTypes = {
    pictures: PropTypes.array,
    startIndex: PropTypes.number,
    lastIndex: PropTypes.number,
    selectedId: PropTypes.number,
    onSelected: PropTypes.func
};

export default PictureAdapter;



// WEBPACK FOOTER //
// ./src/components/elements/PictureAdapter/PictureAdapter.js